var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-light m-5 text-center"},[_c('h1',[_vm._v("Whoops Something Went Wrong")]),_c('router-link',{staticClass:"btn btn-outline-primary rounded-0",attrs:{"to":"/"}},[_vm._v("Go Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }